import { useEffect, useState } from "react";
import { LogOut } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { Logo } from "@/components/site/Logo";
import AdminLogin from "@/components/admin/AdminLogin";
import QuotesList from "@/components/admin/QuotesList";
import PhotosManager from "@/components/admin/PhotosManager";
import { api } from "@/lib/api";

const TABS = [
  { k: "quotes", l: "Zapytania" },
  { k: "photos", l: "Zdjęcia" },
];

export default function AdminPage() {
  const [user, setUser] = useState(null);
  const [tab, setTab] = useState("quotes");

  useEffect(() => {
    document.title = "Panel | TRANSCARS";
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return (
    <div className="min-h-screen bg-[#090A0C] text-zinc-100" data-testid="admin-page">
      <Toaster theme="dark" position="top-center" />
      {user === null && <p className="p-10 text-zinc-400">Ładowanie…</p>}
      {user === false && <AdminLogin onLogin={setUser} />}
      {user && (
        <>
          <header className="sticky top-0 z-30 border-b border-white/10 bg-[#090A0C]/90 backdrop-blur-xl">
            <div className="mx-auto flex h-16 max-w-5xl items-center justify-between px-5">
              <a href="/" data-testid="admin-home-link"><Logo testid="admin-logo" /></a>
              <button data-testid="admin-logout-button" onClick={logout} className="flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-sm hover:bg-white hover:text-black">
                <LogOut className="h-4 w-4" /> Wyloguj
              </button>
            </div>
          </header>
          <main className="mx-auto max-w-5xl px-5 py-10">
            <div className="mb-8 inline-flex rounded-full border border-white/15 p-1">
              {TABS.map((t) => (
                <button key={t.k} data-testid={`admin-tab-${t.k}`} onClick={() => setTab(t.k)} className={`rounded-full px-5 py-2 text-sm font-semibold transition-colors ${tab === t.k ? "bg-white text-black" : "text-zinc-300 hover:text-white"}`}>
                  {t.l}
                </button>
              ))}
            </div>
            {tab === "quotes" ? <QuotesList /> : <PhotosManager />}
          </main>
        </>
      )}
    </div>
  );
}
